import queryString from 'query-string'
import React from 'react'
import styled from 'styled-components'
import { Typography, IconButton } from '@material-ui/core'
import { CallSplit } from '@material-ui/icons'
import { trace } from '../../services/common'
import { colors } from '../../styles'
import { Main, Scrollable } from '../../layouts'
import {
  CombinedTitle,
  Select,
  Button,
  H1,
  H2,
  H3,
  H4,
  P,
  P2,
  Caption,
  Subtitle1,
  Subtitle2,
  DangerButton,
} from '../../components'

const StyledFlexRow = styled.div`
  display: flex;
  margin: 10px 0;

  button {
    margin-right: 14px;
  }
` as any

export const ComponentsLibPage = ({ location }: { location: Location }) => {
  const { error } = queryString.parse(location.search)
  if (error) {
    throw new Error(
      Array.isArray(error) ? error[0].toString() : error.toString()
    )
  }
  return (
    <Main
      titleBlock={
        <CombinedTitle first="Combined" second="Title" color={colors.portal} />
      }
    >
      <Scrollable>
        <H1 gutterBottom>Header 1</H1>
        <H2 gutterBottom>Header 2</H2>
        <H3 gutterBottom>Header 3</H3>
        <P gutterBottom>
          Body text — lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
          enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
          ut aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </P>

        <H4 gutterBottom>Header 4</H4>
        <P2 gutterBottom>
          Body text — lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
          enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
          ut aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </P2>
        <Caption gutterBottom>Caption</Caption>
        <Typography variant="button" gutterBottom>
          Button Text
        </Typography>
        <Subtitle1 gutterBottom>SideNotes</Subtitle1>
        <Subtitle2 gutterBottom>Small SideNotes</Subtitle2>

        <H1 gutterBottom>Buttons</H1>
        <StyledFlexRow>
          <Button variant="contained" color="default">
            Button Text
          </Button>
          <Button variant="contained" color="default" disabled>
            Button Text
          </Button>
        </StyledFlexRow>
        <StyledFlexRow>
          <Button color="default">Button Text</Button>
          <Button color="default" disabled>
            Button Text
          </Button>
        </StyledFlexRow>
        <StyledFlexRow>
          <Button variant="contained" color="primary">
            Button Text
          </Button>
          <Button variant="contained" color="primary" disabled>
            Button Text
          </Button>
        </StyledFlexRow>
        <StyledFlexRow>
          <Button variant="contained" color="primary" size="small">
            Button Text
          </Button>
          <Button variant="contained" color="primary" size="small" disabled>
            Button Text
          </Button>
        </StyledFlexRow>
        <StyledFlexRow>
          <Button color="primary">Button Text</Button>
          <Button color="primary" disabled>
            Button Text
          </Button>
        </StyledFlexRow>
        <StyledFlexRow>
          <Button color="primary" size="small">
            Button Text
          </Button>
          <Button color="primary" size="small" disabled>
            Button Text
          </Button>
        </StyledFlexRow>
        <StyledFlexRow>
          <Button color="primary" variant="outlined">
            Button Text
          </Button>
          <Button color="primary" variant="outlined" disabled>
            Button Text
          </Button>
        </StyledFlexRow>
        <StyledFlexRow>
          <Button color="primary" variant="outlined" size="small">
            Button Text
          </Button>
          <Button color="primary" variant="outlined" size="small" disabled>
            Button Text
          </Button>
        </StyledFlexRow>
        <StyledFlexRow>
          <IconButton color="primary">
            <CallSplit fontSize="small" />
          </IconButton>
          <IconButton color="primary" disabled>
            <CallSplit />
          </IconButton>
        </StyledFlexRow>
        <StyledFlexRow color="error">
          <DangerButton variant="contained">Button Text</DangerButton>
        </StyledFlexRow>
        <StyledFlexRow color="error">
          <Button to="/">Link Button</Button>
        </StyledFlexRow>
        <H1 gutterBottom>Test error</H1>
        <StyledFlexRow>
          <DangerButton variant="contained" to="/lib?error=Test error">
            Simulate Application Error
          </DangerButton>
        </StyledFlexRow>
        <StyledFlexRow>
          <P>Filters</P>
          <Select
            name="status"
            label="Status"
            placeholder="Filter by status"
            value={null}
            onChange={trace}
          >
            {[
              { label: 'Any', status: 'any' },
              { label: 'Published', status: 'published' },
              { label: 'Unpublished', status: 'unpublished' },
              { label: 'Expiring', status: 'expiring' },
            ]}
          </Select>
        </StyledFlexRow>
      </Scrollable>
    </Main>
  )
}
